export const getTombstoneText = ({
  deletedBy,
  deletedByRole,
  myChatId,
  senderChatId,
}) => {
  const isMe = String(deletedBy) === String(myChatId);
  const isSender = String(senderChatId) === String(deletedBy);

  /* ================= ADMIN DELETE ================= */
  if (deletedByRole === "admin") {
    if (isMe) return "You deleted this message as Admin";
    return "This message was deleted by an admin";
  }

  /* ================= SELF DELETE ================= */
  if (isMe) {
    return "You deleted this message";
  }

  /* ================= OTHER USER ================= */
  if (isSender) {
    return "This message was deleted by the sender";
    // or: "They deleted this message"
  }

  return "This message was deleted";
};